import { createRoot } from 'react-dom/client';

import { isDev } from 'shared/config';
import { calculateVh } from 'shared/lib/calculateVh';
import { App } from 'app';
import { connectUpdater } from 'app/updater';

import './app/sentry';

const container = document.getElementById('root');
if (!container) throw new Error('Container not found');

calculateVh();
window.addEventListener('resize', calculateVh);

if (!isDev && 'serviceWorker' in navigator) {
  connectUpdater();
}

const root = createRoot(container);
root.render(<App />);
